




import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'vulnIndex' })
export default class Index extends Vue {}
